import { Flow_0_0_2 } from '@flexus/core';

export const SIL_36: Flow_0_0_2 = {
	id: '36',
	name: 'work_continued',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for team leader to finish'
		}
	},
	startNode: '',
	nodes: {}
};
